import React from 'react';
import css from './css.module.less';
import { cloneDeep } from 'lodash';
import Row from '@/src/components/Layouts/Row/Row';
import { Input, Form, OriSelect, Button } from 'src/components/Antd';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { Icon } from '@/src/tools/icon';
import ModalHOC from 'src/constrains/ModalHOC';
import TopContainer from '@/src/components/Antd/Modal/TopContainer';
import CountWords from '@/src/components/CountWords/CountWords';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import { addOption, checkAttributeAva } from 'src/request/product/product';
import Configuration from '@/src/components/Configuration/Configuration';
import { get } from 'lodash';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Option = OriSelect.Option;
const Item = Form.Item;

export enum EType {
  Dropdown = 'Dropdown',
  InputField = 'InputField',
}

const Attributes = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    avaAtt,
    baseName,
    onAttOptionsChange,
    modalOp,
    productUuid,
    disabled,
  } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;

  const _baseName = 'attributes' || baseName;

  const groupedAtt = React.useMemo(() => {
    const _groupedAtt = [];
    const _avaAtt = cloneDeep(avaAtt);
    while (_avaAtt.length > 0) {
      const group = _avaAtt.splice(0, 2);
      _groupedAtt.push(group);
    }
    return _groupedAtt;
  }, [avaAtt]);

  const brandBtnClick = ({ title, uuid, options }) => {
    setShowModal(true);
    setModalTitle(
      getI18n(
        'allProducts.addproductset.attributes_component___Attributes_option',
      ) + title,
    );
    // setOkText('Create');
    const child = (
      <Row
        elements={[
          {
            child: (
              <AddUnit
                disabled={disabled}
                title={getI18n(
                  'allProducts.addproductset.attributes_component___Attributes_option_title',
                )}
                setModal={setShowModal}
                onSubmit={(option) => {
                  if (onAttOptionsChange) onAttOptionsChange(uuid, option);
                }}
                maxLength={50}
                currentData={options.map((i) => i.value)}
                uuid={uuid}
              />
            ),
          },
        ]}
      />
    );
    setModalContent(child);
  };

  return (
    <React.Fragment>
      {groupedAtt.map((group, index) => {
        const len = (group || []).length;
        const childGenerate = ({ fieldType, uuid, unique, title, options }) => {
          if (fieldType === EType.InputField) {
            return {
              child: (
                <ItemWrapper
                  rightPart={
                    <Item
                      shouldUpdate={(prevValues, curValues) => {
                        const pEnable = get(prevValues, [_baseName, uuid]);
                        const cEnable = get(curValues, [_baseName, uuid]);
                        return pEnable !== cEnable;
                      }}
                      noStyle>
                      {({ getFieldValue }: any) => {
                        const placeholder = getFieldValue([_baseName, uuid]);

                        return (
                          <CountWords
                            count={(placeholder || '').length}
                            allCount={500}
                          />
                        );
                      }}
                    </Item>
                  }
                  title={title}
                  rightSubTitle={
                    unique
                      ? getI18n(
                          'allProducts.addproductset.attributes_component___Attributes_rightSubTitle',
                        )
                      : ''
                  }>
                  <Input
                    maxLength={500}
                    key={uuid}
                    size='large'
                    disabled={disabled}
                    formProps={{
                      name: [_baseName, uuid],
                      rules: [
                        {
                          validator: async (x, value) => {
                            if (value) {
                              const isOccupied = await checkAttributeAva({
                                attributeUuid: uuid,
                                value,
                                productUuid,
                              });
                              if (isOccupied) {
                                return Promise.reject(
                                  new Error(
                                    getI18n(
                                      'allProducts.addproductset.attributes_component___Attributes_duplicate_error',
                                    ),
                                  ),
                                );
                              }
                            }
                          },
                        },
                      ],
                    }}
                  />
                </ItemWrapper>
              ),
            };
          }
          if (fieldType === EType.Dropdown) {
            return {
              child: (
                <React.Fragment>
                  <ItemWrapper
                    title={title}
                    rightSubTitle={
                      unique
                        ? getI18n(
                            'allProducts.addproductset.attributes_component___Attributes_rightSubTitle',
                          )
                        : ''
                    }>
                    <div className={css.dropdownContainer}>
                      <Item
                        rules={[
                          {
                            validator: async (x, value) => {
                              if (value) {
                                const isOccupied = await checkAttributeAva({
                                  attributeUuid: uuid,
                                  value,
                                  productUuid,
                                });
                                if (isOccupied) {
                                  return Promise.reject(
                                    new Error(
                                      getI18n(
                                        'allProducts.addproductset.attributes_component___Attributes_duplicate_error',
                                      ),
                                    ),
                                  );
                                }
                              }
                            },
                          },
                        ]}
                        name={[_baseName, uuid]}
                        className={css.selectItem}>
                        <OriSelect size='large' allowClear disabled={disabled}>
                          {(options || []).map((i) => {
                            const { uuid, value } = i;
                            return (
                              <Option value={uuid} key={uuid}>
                                {value}
                              </Option>
                            );
                          })}
                        </OriSelect>
                      </Item>
                      <Button
                        className={css.addButton}
                        size={'large'}
                        disabled={disabled}
                        onClick={() =>
                          brandBtnClick({ title, uuid, options: options || [] })
                        }>
                        <Icon type={'iconplus'} className={css.icon} />
                      </Button>
                    </div>
                  </ItemWrapper>
                </React.Fragment>
              ),
            };
          }
          return null;
        };
        if (len === 2) {
          return (
            <Row
              key={index}
              elements={(group || []).map((i, index) => {
                const { fieldType, uuid, unique, title, options } = i || {};
                return childGenerate({
                  fieldType,
                  uuid,
                  unique,
                  title,
                  options,
                });
              })}
            />
          );
        }
        if (len === 1) {
          return (
            <Row
              elements={[
                ...(group || []).map((i, index) => {
                  const { fieldType, uuid, unique, title, options } = i || {};
                  return childGenerate({
                    fieldType,
                    uuid,
                    unique,
                    title,
                    options,
                  });
                }),
                ,
                { child: <React.Fragment /> },
              ]}
              key={index}
            />
          );
        }
        return null;
      })}
      <Configuration
        configStart={getI18n(
          'allProducts.addproductset.attributes_component___Attributes_Configuration',
        )}
        linkTo={'/settings/product'}
        configLink={getI18n('general.storeCommunicationSetting.product')}
        configEnd={getI18n('general.section')}
      />
    </React.Fragment>
  );
};

export default ModalHOC(Attributes);

const AddUnit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    setModal,
    onSubmit,
    title,
    maxLength = 50,
    cancelText,
    okText,
    currentData = [],
    uuid,
    disabled,
  } = props;
  //console.log('currentData', currentData);
  const [unit, setUnit] = React.useState('');
  const [err, setErr] = React.useState(false);
  const onChange = (e) => {
    setUnit(e);
    if (err) setErr(false);
  };
  const onCancel = () => {
    if (setModal) setModal(false);
  };
  const onOk = () => {
    // if (!unit || unit.match(/^\s*$/)) {
    //   setErr(true);
    //   return;
    // }

    if (currentData.find((i) => i === unit)) {
      setErr(true);
      return;
    }
    addOption(uuid, { value: unit }).then((res) => {
      if (onSubmit) {
        onSubmit(res);
        setModal(false);
      }
    });
    // if (onSubmit) onSubmit(unit);
    // if (setModal && !externalClose) setModal(false);
  };
  return (
    <Row
      elements={[
        {
          child: (
            <React.Fragment>
              <TopContainer>
                <ItemWrapper
                  title={title}
                  rightPart={
                    <CountWords
                      count={(unit || '').length}
                      allCount={maxLength}
                    />
                  }>
                  <Input
                    help={getI18n(
                      'allProducts.addproductset.attributes_component___Attributes_input',
                    )}
                    error={err}
                    autoFocus
                    size='large'
                    value={unit}
                    onChange={onChange}
                    maxLength={maxLength}
                    disabled={disabled}
                  />
                </ItemWrapper>
              </TopContainer>
              <ModalFooter
                onCancel={onCancel}
                cancelText={cancelText}
                okText={okText}
                onOk={onOk}
              />
            </React.Fragment>
          ),
        },
      ]}
    />
  );
};
